import axios from './axiosInstance'
import {OpenerCloserObject} from "../types/opernerCloserTypes";
import {Song, SupportedSports} from "../types/generic";
import {SupportedHighlightTypes} from "../types/highlightTypes";
const baseUrl = process.env.REACT_APP_BASE_URL+"/highlight";

export async function suggestClips(jobIds: string[], eventIds: string[], maxDuration: number, minDuration: number,  highlight_type: SupportedHighlightTypes, player?: string){
    const body: any = {jobs: jobIds, events: eventIds, max_duration: maxDuration, min_duration: minDuration, highlight_type}
    if(player){
        body.player = player;
    }
    const response = await axios.post(`${baseUrl}/suggestClips`, body)
    return response.data;
}

export async function createHighlight(
    clipIds: string[],
    selectedOpener: OpenerCloserObject,
    selectedCloser: OpenerCloserObject,
    audioFading: boolean = false,
    audioFadingDuration?: number,
    type?: SupportedHighlightTypes,
    song?: Song,
    player?: string
    )
{
    const body: any = {
        clips: clipIds,
        opener: selectedOpener.id !== "" ? selectedOpener.id : null,
        closer: selectedCloser.id !== "" ? selectedCloser.id : null,
        type: type,
    };
    if(audioFading){
        body.fade = true;
    }
    if(audioFadingDuration){
        body.fade_duration = audioFadingDuration;
    }
    if(song){
        body.music = song;
    }
    if(type === 'Pistolero' && player){
        body.player = player;
    }

    const response = await axios.post(`${baseUrl}`, body)
    return response.data;
}

export async function deleteHighlight(highlightId: string){
    const response = await axios.delete(`${baseUrl}/deleteHighlight/${highlightId}`);
    return response.data;
}

export async function getSongs(): Promise<Song[]>{
    const response = await axios.get(`${baseUrl}/songs`);
    return response.data;
}

export async function getPistoleroOptions(eventId: string): Promise<string[]>{
    const response = await axios.get(`${baseUrl}/pistoleros/${eventId}`);
    return response.data;
}


